export default __webpack_public_path__ + "static/media/clickstreams_upload_your_video.37129048.gif";